export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 bg-background-100 rounded-xl p-8 md:p-12 border border-background-200/60">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                随时随地 · 移动端看剧
              </h2>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-[480px] mx-auto lg:mx-0">
                樱花TV移动版完美适配手机和平板，无论在地铁、咖啡厅还是床上，打开浏览器即可畅享全高清影视体验。无需下载APP，无需占用存储空间，流畅播放不缓冲。
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3 justify-center lg:justify-start">
                <div className="flex items-center gap-2 text-sm text-foreground-700 bg-background-50 px-3 py-1.5 rounded-lg border border-background-200/60">
                  <i className="ri-smartphone-line text-primary-500" />
                  <span>手机端适配</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-700 bg-background-50 px-3 py-1.5 rounded-lg border border-background-200/60">
                  <i className="ri-tablet-line text-primary-500" />
                  <span>平板端适配</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-700 bg-background-50 px-3 py-1.5 rounded-lg border border-background-200/60">
                  <i className="ri-wifi-line text-primary-500" />
                  <span>无需下载</span>
                </div>
              </div>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-qr-scan-line text-lg" />
                扫码体验移动版
              </a>
            </div>

            <div className="w-full max-w-[320px] shrink-0">
              <div className="relative mx-auto w-[200px] aspect-[9/16] bg-background-200 rounded-2xl overflow-hidden border-4 border-background-300/60 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20mockup%20showing%20a%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20and%20a%20warm%20dark%20theme%2C%20modern%20UI%20design%2C%20clean%20layout%20with%20content%20cards%2C%20cinematic%20color%20palette%20with%20deep%20reds%20and%20warm%20golds%2C%20sleek%20minimalist%20aesthetic&width=400&height=700&seq=app-mockup&orientation=portrait"
                  alt="樱花TV移动版界面预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}